import PropTypes from 'prop-types'
import React from 'react'

import atSignIcon from './assets/at-sign.svg'
import backArrowIcon from './assets/back-arrow.svg'
import logoIcon from './assets/logo.svg'
import phoneIcon from './assets/phone.svg'

import {
  BackIcon,
  BackLink,
  DesktopContactLink,
  DesktopContacts,
  Header,
  Inner,
  LogoIcon,
  LogoLink,
  MobileActionIcon,
  MobileActionLink,
  MobileActions,
} from './styles'

const CartRouteHeader = ({ headerRef }) => {
  return (
    <Header ref={headerRef}>
      <Inner>
        <BackLink asPath="/" label="На главную" to="/">
          <BackIcon alt="" aria-hidden="true" src={backArrowIcon} />
        </BackLink>

        <LogoLink asPath="/" label="Атлас" to="/">
          <LogoIcon alt="" aria-hidden="true" src={logoIcon} />
        </LogoLink>

        <DesktopContacts>
          <DesktopContactLink
            $isUnderline={true}
            asPath="mailto:hello@atlas.ru"
            component="a"
            label="hello@atlas.ru"
            to=""
          >
            hello@atlas.ru
          </DesktopContactLink>
          <DesktopContactLink
            asPath="tel:+78005000648"
            component="a"
            label="8 800 500 06 48"
            to=""
          >
            8 800 500 06 48
          </DesktopContactLink>
        </DesktopContacts>

        <MobileActions>
          <MobileActionLink
            asPath="tel:+78005000648"
            component="a"
            label="Позвонить"
            to=""
          >
            <MobileActionIcon alt="" aria-hidden="true" src={phoneIcon} />
          </MobileActionLink>
          <MobileActionLink
            asPath="mailto:hello@atlas.ru"
            component="a"
            label="Написать"
            to=""
          >
            <MobileActionIcon alt="" aria-hidden="true" src={atSignIcon} />
          </MobileActionLink>
        </MobileActions>
      </Inner>
    </Header>
  )
}

CartRouteHeader.propTypes = {
  headerRef: PropTypes.object,
}

CartRouteHeader.defaultProps = {
  headerRef: null,
}

export default React.memo(CartRouteHeader)
